import { render, staticRenderFns } from "./PortalTitle.vue?vue&type=template&id=c7631b96&scoped=true&"
import script from "./PortalTitle.vue?vue&type=script&lang=js&"
export * from "./PortalTitle.vue?vue&type=script&lang=js&"
import style0 from "./PortalTitle.vue?vue&type=style&index=0&id=c7631b96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7631b96",
  null
  
)

export default component.exports